import type { ApplyProposalInput, ExtractionJob } from "@shared/modules/x-extraction";
import { api } from "../../../core/lib/api";

export interface EngineState {
  ollama: { baseUrl: string; model: string; available: boolean };
  autoCv: boolean;
  queue: Record<string, number>;
}

export function engineState(): Promise<EngineState> {
  return api<EngineState>("/api/extraction/etat");
}

export function listJobs(filter: { candidateId?: string; status?: string } = {}): Promise<ExtractionJob[]> {
  const params = new URLSearchParams();
  if (filter.candidateId) params.set("candidateId", filter.candidateId);
  if (filter.status) params.set("status", filter.status);
  return api<ExtractionJob[]>(`/api/extraction/jobs?${params.toString()}`);
}

export function getJob(id: string): Promise<ExtractionJob & { anonymizedPreview?: string | null }> {
  return api(`/api/extraction/jobs/${id}?preview=1`);
}

export function applyJob(id: string, input: ApplyProposalInput): Promise<ExtractionJob> {
  return api<ExtractionJob>(`/api/extraction/jobs/${id}/appliquer`, { method: "POST", body: JSON.stringify(input) });
}

export function rejectJob(id: string): Promise<ExtractionJob> {
  return api<ExtractionJob>(`/api/extraction/jobs/${id}/rejeter`, { method: "POST" });
}

export function requeueJob(id: string): Promise<ExtractionJob> {
  return api<ExtractionJob>(`/api/extraction/jobs/${id}/relancer`, { method: "POST" });
}

/** Importation de CV sans dossier : point d'entrée du module x-documents (appel d'API seulement). */
export async function importCvs(files: File[]): Promise<{ created: { id: string }[]; rejected: { name: string; reason: string }[] }> {
  const form = new FormData();
  for (const f of files) form.append("fichiers", f, f.name);
  const res = await fetch(`${import.meta.env.VITE_API_BASE_URL || ""}/api/documents/importations`, { method: "POST", body: form, credentials: "include" });
  const body = (await res.json().catch(() => ({ created: [], rejected: [] }))) as { created: { id: string }[]; rejected: { name: string; reason: string }[] };
  if (!res.ok && !body.created?.length) throw new Error("importation refusée");
  return body;
}
